/**
 * @generated SignedSource<<808cb4eb4ed9f702682dbb8531e12aa5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AmountFor = "ASSET" | "FIAT";
export type CreateTradeOfferErrorCode = "INVESTMENT_NORMAL_LIMIT_REACHED" | "INVESTMENT_ZERO_LIMIT_REACHED";
export type FiatTransactionStatus = "APPROVED" | "CANCELLED" | "CREDITED" | "FINISHED" | "INITIATED" | "MANUAL_REVIEW" | "PENDING" | "PROCESSING" | "REFUNDED" | "REJECTED";
export type TradeOfferOperation = "BUY" | "SELL";
export type CreateTradeOfferInput = {
  amount: string;
  amountFor: AmountFor;
  assetId: string;
  operation: TradeOfferOperation;
};
export type CreateTradeOfferMutation$variables = {
  input?: CreateTradeOfferInput | null | undefined;
};
export type CreateTradeOfferMutation$data = {
  readonly createTradeOffer: {
    readonly __typename: "CreateTradeOfferError";
    readonly code?: CreateTradeOfferErrorCode;
    readonly deepLink?: string;
    readonly details?: {
      readonly currentInvestedAmount: PrecisionFloat | null | undefined;
      readonly maxLimitAmount: PrecisionFloat | null | undefined;
      readonly remainingBalanceAmount: PrecisionFloat | null | undefined;
      readonly requestedAmount: PrecisionFloat | null | undefined;
    } | null | undefined;
    readonly fiatTransaction?: {
      readonly id: string;
      readonly status: FiatTransactionStatus;
    };
    readonly offer?: {
      readonly " $fragmentSpreads": FragmentRefs<"CreateTradeOfferMutationFragment">;
    } | null | undefined;
    readonly paymentLink?: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"CreateTradeOfferMutationFragment">;
  } | null | undefined;
};
export type CreateTradeOfferMutation = {
  response: CreateTradeOfferMutation$data;
  variables: CreateTradeOfferMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "CreateTradeOfferMutationFragment"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deepLink",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeOffer",
  "kind": "LinkedField",
  "name": "offer",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentLink",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "FiatTransaction",
  "kind": "LinkedField",
  "name": "fiatTransaction",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "CreateTradeOfferErrorDetails",
  "kind": "LinkedField",
  "name": "details",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "requestedAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentInvestedAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxLimitAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingBalanceAmount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetConversionRate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expiresAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasTaxOfflineWarning",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spread",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "TradeOffer",
  "kind": "LinkedField",
  "name": "offer",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v6/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateTradeOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createTradeOffer",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v2/*: any*/),
            "type": "TradeOffer",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "TradeOfferSignatureNeeded",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v4/*: any*/)
            ],
            "type": "TradeOfferFiatDepositNeeded",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "type": "CreateTradeOfferError",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateTradeOfferMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "createTradeOffer",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "type": "TradeOffer",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v17/*: any*/)
            ],
            "type": "TradeOfferSignatureNeeded",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v17/*: any*/)
            ],
            "type": "TradeOfferFiatDepositNeeded",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "type": "CreateTradeOfferError",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v6/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4dd1185e7c43fbe7f1703aede4b28dcf",
    "id": null,
    "metadata": {},
    "name": "CreateTradeOfferMutation",
    "operationKind": "mutation",
    "text": "mutation CreateTradeOfferMutation(\n  $input: CreateTradeOfferInput\n) {\n  createTradeOffer(input: $input) {\n    __typename\n    ... on TradeOffer {\n      ...CreateTradeOfferMutationFragment\n    }\n    ... on TradeOfferSignatureNeeded {\n      deepLink\n      offer {\n        ...CreateTradeOfferMutationFragment\n        id\n      }\n    }\n    ... on TradeOfferFiatDepositNeeded {\n      paymentLink\n      fiatTransaction {\n        id\n        status\n      }\n      offer {\n        ...CreateTradeOfferMutationFragment\n        id\n      }\n    }\n    ... on CreateTradeOfferError {\n      __typename\n      code\n      details {\n        requestedAmount\n        currentInvestedAmount\n        maxLimitAmount\n        remainingBalanceAmount\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment CreateTradeOfferMutationFragment on TradeOffer {\n  __typename\n  id\n  fiatAmount\n  assetAmount\n  assetConversionRate\n  expiresAt\n  hasTaxOfflineWarning\n  spread\n}\n"
  }
};
})();

(node as any).hash = "ed300cf0bfc01a48ded3632363f3fe67";

export default node;
